<template>
  <WdsText v-if="column.rate != null">
    {{ column.currency }} {{ column.rate.toLocaleString(locale) }}
    <br />
    {{ rateType }}
  </WdsText>
  <WdsText v-else>
    —
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { RateType } from '@/gql/graphql'
import { $t } from '@/composables/translation'

const locale = currentLocale

const RateColumn = graphql(`
  fragment RateColumnHire on Hire {
    rate
    rateType
    currency
    hasMilestones
  }
  fragment RateColumnJob on Job {
    rate
    rateType
    currency
  }
  fragment RateColumnBid on Bid {
    rate
    rateType
    currency
  }
`)

const props = defineProps<{ row: FragmentType<typeof RateColumn> }>()
const column = computed(() => useFragment(RateColumn, props.row))
const rateType = computed(() => {
  if (column.value.hasMilestones) {
    return $t('Milestones')
  }
  switch (column.value.rateType) {
    case RateType.Hourly:
      return $t('Hourly')
    case RateType.Daily:
      return $t('Daily')
    case RateType.Weekly:
      return $t('Weekly')
    case RateType.Monthly:
      return $t('Monthly')
    case RateType.Fixed:
      return $t('Fixed')
    case RateType.Unknown:
      return $t('Unknown')
    default:
      return ''
  }
})
</script>
